import { Component, OnInit } from '@angular/core';
import { DataService } from '../data.service';
import { GeneralService } from '../general.service';
import {TranslateService} from '@ngx-translate/core';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { Session } from 'protractor';

@Component({
  selector: 'app-loadexam',
  templateUrl: './loadexam.component.html',
  styleUrls: ['./loadexam.component.scss']
})
export class LoadexamComponent implements OnInit {

  public logo = "";

  constructor(
    public dataSvc: DataService,
    public generalSvc: GeneralService,
    public translate: TranslateService
  ) {

    var exisitingLangauge = localStorage.getItem("userslanguage");
    if(exisitingLangauge !== null && exisitingLangauge !== undefined && exisitingLangauge !== ""){
      this.dataSvc.changeLangauge(exisitingLangauge);
    }
    else{
      this.translate.setDefaultLang("en");
      this.translate.use("en");
    }

    if (dataSvc.currentUser.ScheduleCandidate == null || dataSvc.currentUser.Exams.length == 0)
      generalSvc.logoutUser();

    //if (dataSvc.currentExamIndex == -1)
      //generalSvc.loginUser();

    if (dataSvc.currentExam().Session.TimeTakenInSeconds > 0)
      this.resumeExam();
    
    if (dataSvc.currentUser.Exams[dataSvc.currentExamIndex].Session.AssessmentFrontPageText == null || dataSvc.currentUser.Exams[dataSvc.currentExamIndex].Session.AssessmentFrontPageText == "")
      this.startExam();
  }

  ngOnInit() {
  }

  

  startExam() {
    this.dataSvc.currentUser.Exams[this.dataSvc.currentExamIndex].Status = 3;
    this.dataSvc.currentUser.Exams[this.dataSvc.currentExamIndex].StatusText = "Started";

    var sessionId = this.dataSvc.currentUser.Exams[this.dataSvc.currentExamIndex].Session.SessionId;
    if(sessionId !== null && sessionId !== undefined && sessionId > 0){
      this.dataSvc.updateSessionStatus(sessionId, 3);

      const sessionIndex = this.dataSvc.sessions.findIndex(x => x.SessionId === sessionId);
      this.dataSvc.sessions[sessionIndex].Status = 3;
      const syncIndex = this.dataSvc.syncItems.findIndex(x => x.object === 'sessions');
      localStorage.setItem("syncItem" + syncIndex, JSON.stringify(this.dataSvc.sessions));
    }
    this.initiateTimer();
    this.resumeExam();
  }

  initiateTimer(){
    var timerMins = 0;
    var questions = this.dataSvc.currentUser.Exams[this.dataSvc.currentExamIndex].Questions;
    for(var q = 0; q < questions.length; q++){
      var question = questions[q].Question;
      if(question != null){
        var qTime = question.QuestionTime;
        if(qTime !== null){
          timerMins += qTime;
        }
      }
    }

    var adaptedTime = 0;
    var scheduleCandidate = this.dataSvc.currentUser.ScheduleCandidate;
    if(scheduleCandidate != null){
      if(scheduleCandidate.ExtraTime != null && scheduleCandidate.ExtraTime > 0){
        adaptedTime += scheduleCandidate.ExtraTime;
      }
    }

    timerMins += adaptedTime;
    
     var startTime = new Date();
     var endTime = new Date();
     endTime.setMinutes(endTime.getMinutes() + timerMins);
     endTime = new Date(endTime);

    if(this.dataSvc.currentUser.Exams[this.dataSvc.currentExamIndex].Session.TimeStarted == null 
      || this.dataSvc.currentUser.Exams[this.dataSvc.currentExamIndex].Session.TimeStarted == ""){
        this.dataSvc.currentUser.Exams[this.dataSvc.currentExamIndex].Session.TimeStarted = startTime;
    }

    if(this.dataSvc.currentUser.Exams[this.dataSvc.currentExamIndex].Session.ExpectedEndTime == null
      || this.dataSvc.currentUser.Exams[this.dataSvc.currentExamIndex].Session.ExpectedEndTime == ""){
        this.dataSvc.currentUser.Exams[this.dataSvc.currentExamIndex].Session.ExpectedEndTime = endTime;
    }    
  }

  resumeExam() {
    this.generalSvc.launchExamQuestions();
    this.dataSvc.startSyncMethods();
  }
}
